import React from 'react';
import IconButton from 'material-ui/IconButton';
import Close from 'material-ui/svg-icons/navigation/close';
import Dialog from 'material-ui/Dialog';
import Aox from '../hoc/Aox';

export default class ModalInformation extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };


  render() {
    return (
      <Aox>
        <span className="btn--open-info-modal" onClick={this.handleOpen}>
          <span className="icon" />
        </span>
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          className="modal modal--information"
          autoScrollBodyContent={true}
        >
          <div className="modal-content">
            <div className="container-text">
              <div className="close-container">
                <div className="flex space-between">
                  <IconButton
                    label="Close"
                    onClick={this.handleClose}
                    className="btn--close"
                  >
                    <Close />
                  </IconButton>
                </div>
              </div>
              {this.props.children}
            </div>
          </div>
        </Dialog>
      </Aox>
    );
  }
}